import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";

export interface RenderActionProps {
  message: string;
}

export const RenderAction = ({
  message,
}: RenderActionProps) => {
  return (
    <pre className="break-words whitespace-pre-wrap">
      <Markdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ node, ...props }) => (
            <a
              className="text-blue-600 underline"
              {...props}
              target="_blank"
            >
              {props.children}
            </a>
          ),
        }}
      >
        {message}
      </Markdown>
    </pre>
  );
};
